module.exports = __webpack_public_path__ + "img/2014_S.20a82cfc.png";